export default {
    delimiters: ['{(', ')}'],
    props: ['show', 'scenario', 'success-message', 'error-message'],
    data() {
        return {
            mail: '',
            isLoading: false,
            feedback: '',
            success: false
        }
    },
    methods: {
        submit(e) {
            e.preventDefault();
            this.feedback = '';

            this.isLoading = true;

            const currentLanguage = document.documentElement.getAttribute('lang') || 'en';
            let scenario = this.scenario;
            scenario.email = this.mail;

            // Start fetch
            fetch('/share', {
                method: 'POST',
                body: JSON.stringify(scenario),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': (currentLanguage === 'en' ? 'en-US,en' : 'fr-CA,fr') + ';q=0.9'
                }
            }).then(response => {
                return response.json();
            }).then(response => {
                this.isLoading = false;
                this.success = response && response.success

                this.feedback = response.feedback;

                // Success
                if (this.success) {
                    this.mail = '';
                }
            }).catch(error => {
                this.isLoading = false;
                console.error('[App.Form.submitForm]', error);
            });
        }
    },
    updated() {
        document.documentElement.classList.toggle('has-modal-opened', this.show)
    },
    unmounted() {
        document.documentElement.classList.remove('has-modal-opened')
    },
    template: '#quiz-results-modal'
}
